import React, { createContext, useContext, useState, useEffect } from 'react';

const StoreHistoryContext = createContext();

export const useStoreHistory = () => {
  const context = useContext(StoreHistoryContext);
  if (!context) {
    throw new Error('useStoreHistory must be used within a StoreHistoryProvider');
  }
  return context;
};

export const StoreHistoryProvider = ({ children }) => {
  const [storeHistory, setStoreHistory] = useState(() => {
    const savedHistory = localStorage.getItem('storeHistory');
    return savedHistory ? JSON.parse(savedHistory) : [];
  });

  useEffect(() => {
    localStorage.setItem('storeHistory', JSON.stringify(storeHistory));
  }, [storeHistory]);

  const addToHistory = (storeUrl, freeProductCount) => {
    setStoreHistory(prev => {
      const newHistory = prev.filter(item => item.url !== storeUrl);
      return [
        { 
          url: storeUrl, 
          freeProductCount, 
          lastVisited: new Date().toISOString(),
          visitCount: (prev.find(item => item.url === storeUrl)?.visitCount || 0) + 1
        },
        ...newHistory
      ].slice(0, 10); // Keep only last 10 stores
    });
  };

  const clearHistory = () => {
    setStoreHistory([]);
    localStorage.removeItem('storeHistory');
  };

  return (
    <StoreHistoryContext.Provider value={{ storeHistory, addToHistory, clearHistory }}>
      {children}
    </StoreHistoryContext.Provider>
  );
}; 